import * as React from 'react';
import styled from 'styled-components';

const TabContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  overflow: hidden;
`;

const ComponentContainer = styled.div`
  height: 1px;
  flex: 1 1;
  overflow: auto;
`;
const FooterContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }
`;

export interface SettingsTabLayoutProps {
  footer: JSX.Element;
}

export const SettingsTabLayout = ({ children, footer }: React.PropsWithChildren<SettingsTabLayoutProps>) => {
  return (
    <TabContainer>
      <ComponentContainer>{children}</ComponentContainer>
      <FooterContainer>{footer}</FooterContainer>
    </TabContainer>
  );
};
